// Function to style Shadow DOM elements - only right position
function styleShadowDOM() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (node.tagName && node.tagName.toLowerCase().includes('konvo')) {
                        styleWidget(node);
                    }
                    
                    const shadowRoots = node.querySelectorAll ? 
                        Array.from(node.querySelectorAll('*')).filter(el => el.shadowRoot) : [];
                    
                    shadowRoots.forEach(el => styleWidget(el));
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    const existingWidgets = document.querySelectorAll('konvo-widget, [data-testid*="widget"], .ui-widget-wrapper');
    existingWidgets.forEach(widget => styleWidget(widget));
}

function styleWidget(widget) {
    if (!widget.shadowRoot) return;

    const style = document.createElement('style');
    style.textContent = `
       @media(max-width:768px){
        .ui-widget-wrapper {
            right: 30px !important;
        }
       }
    `;

    const existingStyle = widget.shadowRoot.querySelector('style[data-custom-widget-style]');
    if (existingStyle) {
        existingStyle.remove();
    }
    
    style.setAttribute('data-custom-widget-style', 'true');
    widget.shadowRoot.appendChild(style);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleShadowDOM);
} else {
    styleShadowDOM();
}

setTimeout(styleShadowDOM, 2000);
setTimeout(styleShadowDOM, 5000);